import type { JSX } from 'react';

import { PetitionCard } from '@change-corgi/design-system-legacy/components/content';

import type { VictoriousPetition } from '../../../../../../shared/api';
import type { SuggestedPetitionSourceLocation } from '../../../../../../shared/types';

import { useVictoriousPetitionCard } from './hooks/useVictoriousPetitionCard';

type Props = Readonly<{
	petition: VictoriousPetition;
	parentPetitionId?: string;
	gridPosition: number;
	sourceLocation: SuggestedPetitionSourceLocation;
}>;

export function VictoriousPetitionCard({
	petition,
	parentPetitionId,
	gridPosition,
	sourceLocation,
}: Props): JSX.Element {
	const {
		data: { petitionUrl, photoUrl },
		actions: { trackClick },
	} = useVictoriousPetitionCard({
		parentPetitionId,
		petition,
		gridPosition,
		sourceLocation,
	});

	return (
		<PetitionCard
			descriptionHtml={petition.node.description}
			heading={petition.node.ask}
			imageUrl={photoUrl}
			onEllipsisClick={() => trackClick('ellipsis')}
			onHeadingClick={() => trackClick('title')}
			petitionId={petition.node.id}
			petitionUrl={petitionUrl}
			showSignButton={false}
			showVictory
			supporterCount={petition.node.signatureState.signatureCount.displayed}
			supporterCountLocalized={petition.node.signatureState.signatureCount.displayedLocalized}
			userName={petition.node.user.displayName}
			userAvatarSrc={petition.node.user.photo?.userSmall.url}
		/>
	);
}
